import './NoiseEffect.css';

export default function NoiseEffect() {
    return (
        <div className="NoiseEffect"></div>
    )
}